<template>
  <div class="coupon-wrapper">
    <section class="coupon-cell">
      <div class="title">优惠券({{list.length}})：</div>
      <div class="content" @click="showPopup">
        <template v-if="active">
          <span>{{showName}}</span>
        </template>
        <template v-else-if="list.length">{{list.length}}张可用</template>
        <template v-else>暂无可用</template>
      </div>
    </section>
    <mt-popup v-model="visible" :modal="false" position="right" class="coupon-popup">
      <div class="coupon-container">
        <div class="coupon-hd">
          <input type="button" class="btn" value="不使用优惠券" @click="cancelUseCoupon">
        </div>
        <div class="coupon-bd">
          <div class="coupon-item" v-for="item in list" :key="item.id" :class="{active: active === item.id}" @click="changeCoupon(item)">
            <div class="content">
              <h2>{{item.couponName}}</h2>
              <p>{{item.couponSubject}}</p>
            </div>
            <div class="price">
              <em>¥</em>
              <span>{{item.couponDiscountAmount}}</span>
            </div>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
export default {
  name: 'CouponCell',
  props: {
    value: { type: String, default: '' },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false,
      active: '',
      showName: ''
    }
  },
  watch: {
    value(value) {
      this.active = value || ''
    },
    active(value) {
      if (value) {
        let item = this.list.filter(item => item.id === value).pop()
        this.showName = item.couponName
      } else {
        this.showName = ''
      }
    }
  },
  methods: {
    // 显示使用优惠券
    showPopup() {
      this.visible = true
    },
    // 取消使用优惠券
    cancelUseCoupon() {
      this.active = ''
      this.$emit('input', '')
      this.$emit('change', null)
      this.visible = false
    },
    // 修改优惠券
    changeCoupon(item) {
      this.active = item.id
      this.$emit('input', item.id)
      this.$emit('change', item)
      this.visible = false
    }
  },
  created() {
    this.active = this.value
  }
}
</script>
<style>
/* 优惠券 */
.mint-popup.coupon-popup {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  overflow-y: auto;
}
.coupon-cell {
  display: flex;
  align-items: center;
  padding: 0 0.2rem;
  margin-bottom: 0.14rem;
  background-color: #fff;
}
.coupon-cell .title {
  padding: 0.16rem 0;
  font-size: 16px;
  line-height: 0.22rem;
  color: #3c3c3c;
}
.coupon-cell .content {
  position: relative;
  flex: 1;
  text-align: right;
  padding: 0.16rem 0.12rem 0.16rem 0;
}
.coupon-cell .content::after {
  content: ' ';
  position: absolute;
  top: 50%;
  right: 0;
  width: 0.08rem;
  height: 0.08rem;
  transform: translateY(-50%) rotate(45deg);
  border: 1px solid #dadada;
  border-bottom-width: 0;
  border-left-width: 0;
}
.coupon-cell .content span {
  color: #ff6260;
}
.coupon-container {
  padding: 0.2rem 0.2rem;
}
.coupon-container .coupon-hd .btn {
  width: 100%;
  display: block;
  background-color: #fff;
}
.coupon-item {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  background-color: #fff;
  border-radius: 4px;
}
.coupon-item.active::after {
  content: '';
  position: absolute;
  top: -2px;
  right: -2px;
  width: 0.26rem;
  height: 0.26rem;
  background: url(../assets/img/coupon_select.png) no-repeat;
  background-size: contain;
}
.coupon-item .content {
  flex: 1;
  padding: 0.2rem;
}
.coupon-item .content h2 {
  font-size: 16px;
  font-weight: 500;
  color: #3c3c3c;
}
.coupon-item .content p {
  font-size: 12px;
  color: #999;
  margin-top: 0.08rem;
}
.coupon-item .price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  width: 0.95rem;
  min-height: 0.54rem;
  height: 100%;
  margin-top: 0.12rem;
  margin-bottom: 0.12rem;
  border-left: 1px dashed #dadada;
}
.coupon-item .price::after {
  content: '';
  position: absolute;
  top: -0.05rem;
  right: 0.9rem;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  background-color: #f6f6f6;
}
.coupon-item .price::before {
  content: '';
  position: absolute;
  bottom: -0.05rem;
  right: 0.9rem;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  background-color: #f6f6f6;
}
.coupon-item .price em {
  font-size: 16px;
  color: #ff6260;
}
.coupon-item .price span {
  font-size: 28px;
  color: #ff6260;
  line-height: 0.54rem;
}
</style>
